export { default as ProductViewReviews } from './ProductViewReviews';
